import {
  HomeOutlined,
  FolderOutlined,
  EnvironmentOutlined,
  BookOutlined,
  CodeOutlined,
  TeamOutlined,
  ApiOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { SidebarItem } from '_/components/common/layout/AppSidebar';
import { useOrgPermissions, OrgRole } from '_/hooks/usePermissions';
import React, { useMemo } from 'react';

// Create icon elements once to prevent re-renders
const homeIcon = <HomeOutlined />;
const folderIcon = <FolderOutlined />;
const environmentIcon = <EnvironmentOutlined />;
const bookIcon = <BookOutlined />;
const codeIcon = <CodeOutlined />;
const teamIcon = <TeamOutlined />;
const apiIcon = <ApiOutlined />;
const settingIcon = <SettingOutlined />;

export function useOrganizationSidebarItems(orgSlug: string): SidebarItem[] {
  const { checkAccess } = useOrgPermissions();
  const isAdmin = checkAccess(OrgRole.ADMIN);

  return useMemo(() => {
    const items: SidebarItem[] = [
      {
        icon: homeIcon,
        text: 'Organization Home',
        href: `/orgs/${orgSlug}/home`,
      },
      {
        icon: folderIcon,
        text: 'Projects',
        href: `/orgs/${orgSlug}/projects`,
      },
      {
        icon: environmentIcon,
        text: 'Destinations',
        href: `/orgs/${orgSlug}/destinations`,
      },
      {
        icon: bookIcon,
        text: 'Schemas',
        href: `/orgs/${orgSlug}/schemas`,
      },
      {
        icon: codeIcon,
        text: 'Extractors',
        href: `/orgs/${orgSlug}/extractors`,
      },
    ];

    if (isAdmin) {
      items.push({
        icon: teamIcon,
        text: 'People',
        href: `/orgs/${orgSlug}/people`,
      });
    }

    items.push(
      {
        icon: apiIcon,
        text: 'Integrations',
        href: `/orgs/${orgSlug}/integrations`,
      },
      {
        icon: settingIcon,
        text: 'Settings',
        href: `/orgs/${orgSlug}/settings`,
      },
    );

    return items;
  }, [orgSlug, isAdmin]);
}
